import * as React from "react";
import Svg, { SvgProps, Path } from "react-native-svg";
const SvgComponent = (props: SvgProps) => (
  <Svg width={20} height={20} fill="none" {...props}>
    <Path
      fill="#000"
      d="m10 15.384-4.897-2.666V8.782l-2.349-1.28L10 3.566l7.257 3.939v5.187h-.77v-4.75l-1.59.843v3.933L10 15.384Zm0-4.814 5.641-3.068-5.64-3.057L4.37 7.502 10 10.57Zm0 3.93 4.128-2.223V9.204L10 11.447 5.872 9.204v3.073L10 14.501Z"
    />
  </Svg>
);
export default SvgComponent;
